export const addSpaceNumber = (value: any) => {
  return new Intl.NumberFormat('ru-RU').format(value);
};
